// Module
var code = "<div class=\"widget-content relative\"> <wt-loading-panel is-loading=\"vm.isLoading\"></wt-loading-panel> <wt-horizontal-bar-chart id=\"{{vm.id}}\" chart-data=\"vm.data\" labels=\"vm.labels\" options=\"vm.options\"></wt-horizontal-bar-chart> </div>";
// Exports
module.exports = code;